import React, {useEffect, useState} from 'react';
import 'datatables.net';
import 'datatables.net-responsive';
import {GET_COL_AGGREGATE_DATA, SEARCH_COLLECTION_URL} from '../../api';
import $ from "jquery";
import {capitalize} from "../../utils/capitalize";
import cogoToast from "cogo-toast";
import moment from "moment/moment";
import {aiPreview, assignment, getPreSignedUrl, uploadPhoto} from "../../api/app";
import {useSelector} from "react-redux";
import DTTask from "../../components/layout/DTTask";
import 'select2';

const Assignment = () => {

    document.title = "Assignment";

    const token = localStorage.getItem('jwtToken');

    const [stateReady, setStateReady] = useState(false);
    const auth = useSelector((state) => state.auth.user);
    const [id, setId] = useState(new Date().getTime());

    useEffect(() => {
        let table = $('#message_table').DataTable({
            responsive: true,
            language: {
                searchPlaceholder: 'Search name',
                sSearch: '',
                lengthMenu: '_MENU_ items/page',
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Assignment Data</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: (data, callback) => {
                $.ajax(GET_COL_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    contentType: 'application/json',
                    data: JSON.stringify({
                        query: $('.dataTables_filter input').val(),
                        collection: "assignments",
                        filter: [
                            {
                                $match: auth.user.role === 'admin' ? {} : {admin: auth.user.sub}
                            },
                            {
                                $lookup: {
                                    from: "tasks",
                                    let: { assignmentId: "$_id" },
                                    pipeline: [
                                        {
                                            $match: {
                                                $expr: { $eq: ["$assignment", "$$assignmentId"] }
                                            }
                                        },
                                        { $count: "count" }
                                    ],
                                    as: "tasks"
                                }
                            },
                            {
                                $addFields: {
                                    tasks_count: {
                                        $ifNull: [{ $arrayElemAt: ["$tasks.count", 0] }, 0]
                                    }
                                }
                            },
                            {
                                $project: {
                                    subject: 1,
                                    description: 1,
                                    status: 1,
                                    type: 1,
                                    social: 1,
                                    admin: 1,
                                    date: 1,
                                    meta: 1,
                                    tasks_count: 1
                                }
                            },
                            {
                                $sort: { _id: -1 } // optional
                            },
                            {
                                $facet: {
                                    results: [
                                        { $skip: data.start },
                                        { $limit: data.length }
                                    ],
                                    totalCount: [
                                        { $count: "total" }
                                    ]
                                }
                            }
                        ]
                    }),
                    success : function(res) {
                        let array = [];
                        res.data[0].results.map((data) => {
                            array.push({raw: data})
                        });

                        callback({
                            recordsTotal: res.data[0].totalCount[0] ? res.data[0].totalCount[0].total : 0,
                            recordsFiltered: res.data[0].totalCount[0] ? res.data[0].totalCount[0].total : 0,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {
                    className: 'dt-control',
                    orderable: false,
                    data: null,
                    defaultContent: '',
                },
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function () {
                        return null;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return `<span class="text-capitalize">${data.subject}</span>`;
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return data.social;
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return data.tasks_count === data.meta.count ? `<span class="badge badge-success tx-white">Success</span>` : `<span class="badge badge-primary tx-white">Progress ${(data.tasks_count/data.meta.count)*100}%</span>`;
                    },
                    "targets": 3
                },
                {
                    "render": function (data) {
                        return moment(data.date.iso).format("Do MMM, YYYY")
                    },
                    "targets": 4
                },
                {
                    "render": function () {
                        return `<nav class="nav nav-icon-only"><a href="#" class="nav-link view_task"><i class="fa fa-eye"></i> View</a> <a href="#" class="nav-link delete_assignment"><i class="fa fa-trash"></i> Delete</a></nav>`
                    },
                    "targets": 5
                }
            ]
        });

        table.on('click', '.delete_assignment', function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();

            $(".data-message").text(`Are you sure, you want to delete this assignment?`);
            $('#delete-data').unbind("click").click(function(){

                $("#modalConfirm").modal("hide");
                $(".modal-backdrop").remove();

                const options = {
                    position: "top-right",
                    hideAfter: 0
                };

                let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

                let data = {
                    id: extract_td.raw._id,
                }

                assignment("delete", data).then((result) => {
                    hide();
                    if(!result.error) {
                        reloadTable();
                        cogoToast.success("Assignment successfully removed.", {position: "top-right"});
                    }
                });
            });

            $("#modalConfirm").modal({ backdrop: 'static', focus: false, show: true });
        });

        table.on('click', '.view_task', function(e) {
            e.preventDefault();

            let extract_td = table.row($(this).closest('tr')).data();
            setId(extract_td.raw._id);
            $("#modalLeaderboard").modal("show");
        });

        $('#message_table tbody').on('click', 'td.dt-control', function () {
            let tr = $(this).closest('tr');
            let row = table.row(tr);

            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
            } else {
                // Open this row
                row.child(format(row.data())).show();
                tr.addClass('shown');
            }
        });

        function format(d) {
            // `d` is the original data object for the row

            return (
                '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">' +
                '<tr>' +
                '<td>Task:</td>' +
                '<td>' +
                d.raw.description +
                '</td>'+
                '</tr>' +
                '</tr>' +
                '<tr>' +
                '<td>Type:</td>' +
                '<td class="text-capitalize">' +
                d.raw.type +
                '</td>'+
                '</tr>' +
                '</tr>' +
                '<tr>' +
                '<td>Total Assigned:</td>' +
                '<td class="text-capitalize">' +
                d.raw?.meta?.count +
                '</td>'+
                '</tr>' +
                '</tr>' +
                // '<tr>' +
                // '<td>Pending:</td>' +
                // '<td class="text-capitalize">' +
                // 0 +
                // '</tr>' +
                // '</tr>' +
                // '<td>Total Submission:</td>' +
                // '<td class="text-capitalize">' +
                // 0 +
                // '</tr>' +
                // '</tr>' +
                '</table>'
            );
        }

        return () => {
            table.destroy();
        }

    }, []);

    const handleShowModal = () => {
        $('#assignment_form').parsley();
        $("#file").prop("disabled", true);
        $("#generate").prop("disabled", true);
        initialize();
        $("#modalAssignment").modal({ backdrop: 'static', focus: false, show: true });
    }

    const resetForm = (id, form) => {
        const parsley = $(`#${form}`).parsley();
        let button_check = $(".button-check");

        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        $(`#${id}`).modal("hide");
        parsley.reset();
        parsley.destroy();

        button_check.text("Submit");
        button_check.removeClass("btn-success");

        $(".modal-backdrop").remove();
    }

    const handleGenerateAssignment = async() => {
        let subject = $('#subject').val();
        let description = $('#description').val();
        let type = $('#type').val();
        let url = $('#url').val();
        let social = $('#social').val();
        let generate = $('#generate').is(':checked');
        let team = auth.user.role === "admin" ? $('#team-select2').val() : [];
        let fileInput = $('#file')[0];
        let file = fileInput?.files[0];

        setStateReady(true);

        let data = {
            subject,
            description,
            social,
            url,
            file_url: file && type === "post" ? await S3Upload(file, (data) => progress(data)) : null,
            type,
            team,
            generate
        }

        $("#modalAI").modal("hide");
        $("#modalAssignment").modal({ backdrop: 'static', focus: false, show: true });

        setTimeout(() => {
            assignment("post", data).then((result) => {
                setStateReady(false);
                if(!result.error) {
                    cogoToast.success("Assignment successfully created.", {position: "top-right", hideAfter: 5});
                    resetForm("modalAssignment", "assignment_form");
                    reloadTable();
                }
            });
        }, 1500);
    }

    const handleAssignmentSubmit = async(e) => {
        e.preventDefault();
        let subject = $('#subject').val();
        let description = $('#description').val();
        let type = $('#type').val();
        let url = $('#url').val();
        let social = $('#social').val();
        let team = auth.user.role === "admin" ? $('#team-select2').val() : [];
        let generate = $('#generate').is(':checked');
        let fileInput = $('#file')[0];
        let file = fileInput?.files[0];

        if(generate) {
            setStateReady(true);

            let data = {
                prompt: description
            }

            aiPreview("post", data).then((result) => {
                setStateReady(false);
                if(!result.error) {
                    setStateReady(false);
                    $("#ai-generated").text(result.payload);
                    $("#modalAssignment").modal("hide");
                    $("#modalAI").modal({ backdrop: 'static', focus: false, show: true });
                }
            });
        } else {
            setStateReady(true);
            let data = {
                subject,
                description,
                social,
                url,
                file_url: file && type === "post" ? await S3Upload(file, (data) => progress(data)) : null,
                type,
                team,
                generate
            }

            assignment("post", data).then((result) => {
                setStateReady(false);
                if(!result.error) {
                    cogoToast.success("Assignment successfully created.", {position: "top-right", hideAfter: 5});
                    resetForm("modalAssignment", "assignment_form");
                    reloadTable();
                }
            });
        }
    }

    const progress = (data) => {
        const btn = $("#progress-bar");
        btn.text(`Uploading ${data}%`);
    }

    const handleTypeChange = (e) => {
        let type = e.target.value;
        let url = $("#url");
        let file =  $("#file");
        let generate = $("#generate");

        if(type === "post") {
            file.prop("disabled", false);
            url.prop("required", false)
        } else {
            file.prop("disabled", true);
            url.prop("required", true)
        }

        if(type === "post" || type === "comment") {
            generate.prop("disabled", false);
        } else {
            generate.prop("disabled", true);
        }
    }

    const S3Upload = (file, onProgress) => {
        return getPreSignedUrl().then(async (response) => {
            if (response.error) return false;

            const headers = {};
            const mimeToExt = {
                "image/jpeg": "jpg",
                "image/png": "png",
                "video/mp4": "mp4"
            };

            const ext = mimeToExt[file.type] ? `.${mimeToExt[file.type]}` : "";

            const buffer = await file.arrayBuffer();

            return uploadPhoto(
                response.payload.url,
                buffer,
                headers,
                onProgress
            ).then((result) => {
                if(!result.error) {
                    return `${result.payload.url.replace(/\?.*$/g, "")}${ext}`;
                }
                return null;
            });
        });
    };

    const handleSocialChange = (e) => {
        let data = e.target.value;
        let url = $("#url");
        let generate = $("#generate");

        const type = $("#type").val();

        if(type === "post") return url.prop("required", false);

        if(data === "radio") {
            url.prop("required", false)
            generate.prop("disabled", true);
        } else {
            url.prop("required", true)
            generate.prop("disabled", false);
        }
    }

    const initialize = () => {
        let modalProduct = $('#modalAssignment');
        $('#team-select2').select2({
            placeholder: 'Select team',
            allowClear: true,
            width:"100%",
            dropdownParent: modalProduct,
            ajax: {
                url: SEARCH_COLLECTION_URL,
                dataType: 'json',
                type: "POST",
                headers: {
                    "Authorization": token
                },
                data: function(query) {
                    return {
                        query: query,
                        collection: "admin"
                    };
                },
                processResults: function(data) {
                    return {
                        results: $.map(data, function(item) {
                            return {
                                text: capitalize(item.name),
                                id: item._id
                            }
                        })
                    };
                }
            }
        }).on('select2:select', function(e){
            $(".select2-search__field").css({display: "none"});
        }).on('select2:unselect', function(e) {
            $(".select2-search__field").css({display: "inline-block"});
        });
    }

    const reloadTable = () => {
        $('#message_table').DataTable().ajax.reload(null, false);
    };

    return (
        <div className="content-body">
            <div className="container-fluid pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item active" aria-current="page">Assignment</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Assignment</h4>
                    </div>
                    <div className="d-none d-md-block">
                        <button className="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5 outline-none" onClick={handleShowModal.bind()}><i className="wd-10 mg-r-5 fa fa-plus"></i> Add Assignment</button>
                    </div>
                </div>

                <div className="row row-sm">
                    <div className="col-md-12 mt-3">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Assignments</h6>
                                <div className="d-flex tx-18">
                                    <a href="javascript:void(0)" className="link-03 lh-0 mg-l-10" onClick={() => reloadTable()}><i className="icon ion-md-refresh"></i></a>
                                </div>
                            </div>
                            <div className="card-body table-responsive">
                                <table id="message_table" className="table" style={{width: "100%"}}>
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th className="wd-20p">Subject</th>
                                        <th className="wd-20p">Social</th>
                                        <th className="wd-20p">Status</th>
                                        <th className="wd-20p">Date</th>
                                        <th className="wd-20p">Actions</th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalAssignment" tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                <a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </a>
                                <div className="media-body">
                                    <a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" onClick={resetForm.bind(null, "modalAssignment", "assignment_form")} aria-label="Close"><span aria-hidden="true">×</span></a>
                                    <h4 className="tx-18 tx-sm-20 mg-b-2">Assignment</h4><p className="tx-13 tx-color-02 mg-b-0">Send task assignment to end users</p>
                                </div>
                            </div>

                            <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                                <form id="assignment_form" className="parsley-style-1" onSubmit={handleAssignmentSubmit.bind()}>
                                    <div id="subjectWrapper" className="form-group parsley-input">
                                        <label>Title of the assigment<span className="tx-danger">*</span></label>
                                        <input id="subject" type="text" className="form-control"
                                               placeholder="Enter subject"
                                               autoComplete="off"
                                               data-parsley-class-handler="#subjectWrapper" required/>
                                    </div>

                                    <div id="typeWrapper" className="form-group parsley-input">
                                        <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5">Type<span className="tx-danger">*</span></label>
                                        <select className="custom-select" id="type" required onChange={handleTypeChange.bind()}>
                                            <option value="" disabled selected>Select Type</option>
                                            <option value="post">Post</option>
                                            <option value="comment">Comment</option>
                                            <option value="report">Report</option>
                                        </select>
                                    </div>

                                    <div id="socialWrapper" className="form-group parsley-input">
                                        <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5">Social<span className="tx-danger">*</span></label>
                                        <select className="custom-select" id="social" required onChange={handleSocialChange.bind()}>
                                            <option value="" disabled selected>Select Social</option>
                                            <option value="facebook">Facebook</option>
                                            {/*<option value="twitter">Twitter</option>*/}
                                            {/*<option value="tiktok">TikTok</option>*/}
                                            {/*<option value="radio">Radio</option>*/}
                                        </select>
                                    </div>

                                    <div id="urlWrapper" className="form-group parsley-input">
                                        <label>Post URL or Link</label>
                                        <input id="url" type="text" className="form-control"
                                               placeholder="Enter url"
                                               autoComplete="off"
                                               data-parsley-class-handler="#urlWrapper"/>
                                    </div>

                                    <div id="fileWrapper" className="form-group parsley-input">
                                        <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5">File Upload (Optional)</label>
                                        <input id="file" type="file" className="form-control"
                                               data-parsley-filemaxmegabytes="10"
                                               data-parsley-trigger="change"
                                               data-parsley-filemimetypes="image/jpeg, image/jpg, image/png, video/mp4"
                                               accept="image/jpeg, image/jpg, image/png, video/mp4"
                                               data-parsley-class-handler="#fileWrapper"
                                        />
                                    </div>

                                    {auth.user.role === "admin" ? <div id="teamWrapper" className="form-group parsley-input">
                                        <div className="d-flex justify-content-between">
                                            <label>Team (Optional)</label>
                                        </div>
                                        <select className="form-control" id="team-select2" data-width="100%"
                                                multiple="multiple"
                                                data-parsley-class-handler="#teamWrapper"
                                                data-parsley-errors-container="#teamWrapper"
                                                autoComplete="off"
                                        >
                                        </select>
                                    </div> : null}

                                    <div id="messageWrapper" className="form-group parsley-input">
                                        <div className="d-flex justify-content-between">
                                            <label>Task<span className="tx-danger">*</span></label>
                                            <div className="custom-control custom-checkbox">
                                                <input className="custom-control-input" type="checkbox" name="_form[]" id="generate" onClick={(e) => {
                                                    let button_check = $(".button-check");
                                                    if(e.target.checked) {
                                                        button_check.text("AI Preview");
                                                        button_check.addClass("btn-success");
                                                    } else {
                                                        button_check.text("Submit");
                                                        button_check.removeClass("btn-success");
                                                    }
                                                }}/>
                                                <label className="custom-control-label" htmlFor="generate">AI Generate</label>
                                            </div>
                                        </div>

                                        <textarea id="description" className="form-control" rows="8" data-parsley-class-handler="#messageWrapper" data-parsley-validation-threshold="10" placeholder="Enter Message..." required></textarea>
                                    </div>

                                    {stateReady ? <button disabled className="btn btn-primary btn-block"><span className="spinner-border spinner-border-sm mg-r-10" role="status" aria-hidden="true"/><span id="progress-bar">Please Wait</span></button> : <button className="btn btn-primary btn-block button-check">Submit</button>}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalAI" tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                <a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </a>
                                <div className="media-body">
                                    <a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" onClick={() => {
                                        $("#modalAI").modal("hide");
                                        let button_check = $(".button-check");
                                        button_check.text("AI Preview");
                                        button_check.addClass("btn-success");
                                        $("#modalAssignment").modal({ backdrop: 'static', focus: false, show: true });
                                    }} aria-label="Close"><span aria-hidden="true">×</span></a>
                                    <h4 className="tx-18 tx-sm-20 mg-b-2">AI Preview</h4><p className="tx-13 tx-color-02 mg-b-0">Generated Sample</p>
                                </div>
                            </div>

                            <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                                <p id="ai-generated">Nothing generated here...</p>
                                <button className="btn btn-primary btn-block mt-5" onClick={handleGenerateAssignment.bind()}>Confirm &amp; Proceed</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalLeaderboard" tabIndex="-1" role="dialog" aria-labelledby="confirmation" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                        <div className="modal-content tx-14">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel6">Assignment Tasks</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => $("#tx-support-level").text("Select Date")}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <DTTask id={id}/>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalConfirm" tabIndex="-1" role="dialog" aria-labelledby="confirmation" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                        <div className="modal-content tx-14">
                            <div className="modal-header">
                                <h6 className="modal-title" id="exampleModalLabel6">Delete Confirm?</h6>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p className="mg-b-0 data-message">Empty</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" id="delete-data" className="btn btn-success btn-block">Yes, Delete</button>
                                <button type="button" className="btn btn-danger btn-block mt-0" data-dismiss="modal">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Assignment;
